<template>

  <div id="audio_btn" @click="stopbgmusicfn()" :class="{'yinfugif':isplaybgmusic}">
    <div id="yinfu" :class="{'rotate':isplaybgmusic}">
    </div>
    <audio id="bgmusic" loop="loop" :musicsrc="resourcepath+'/music/'+filename+'.mp3'">
    </audio>
    <audio id="yinxiao">
    </audio>
  </div>


</template>
<script>
import { mapState } from 'vuex'
import { playbgmusic, stopbgmusic, resourcepath } from '@/commonjs/commonfn.js'
import store from '@/store/index.js'
import loadui from './loadui.vue'
export default {
  components: { loadui },
  name: 'audioui',
  props: ["filename"],
  data() {
    return {
      "resourcepath": resourcepath,
    }
  },
  mounted() { },
  methods: {
    stopbgmusicfn() {
      var isplaymusic = store.state.isplaybgmusic;
      if (isplaymusic == 0) {
        playbgmusic();
      } else {
        stopbgmusic();
      }
    }
  },
  computed: {
    ...mapState(['suodingtipcss', 'yujiazaicss', 'sharetipcontainercss', 'morentanchuangcss', 'chuangtitle', 'fn', 'jindu', 'starcss', 'isalljiazai', 'isplaybgmusic']),
  }
}

</script>
<style scoped>
#audio_btn {
  height: 50px;
  right: 10px;
  position: fixed;
  top: 40px;
  width: 50px;
  z-index: 9999999;
}

.rotate {
  animation: rotating 1.2s linear infinite;
  -webkit-animation: rotating 1.2s linear infinite;
}

.yinfugif {
  background: rgba(0, 0, 0, 0) url("https://oss.zhihuxuetang.cn/suhehuihunian/images/music.gif") no-repeat scroll center center / 60px 60px;
}

#yinfu {
  background-image: url("https://oss.zhihuxuetang.cn/suhehuihunian/images/music_off.png");
  background-size: 100% 100%;
  height: 25px;
  left: 10px;
  position: absolute;
  top: 10px;
  width: 25px;
}

@-webkit-keyframes rotating {
  from {
    -webkit-transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/audioui.vue